import { Link } from '@cbhq/cdx-components';
import { mapEntryLink } from '../globals/navlink.js';
import { jsx } from 'react/jsx-runtime';
function GlobalNavLink(linkProps) {
  const _mapEntryLink = mapEntryLink({
      fields: linkProps
    }),
    url = _mapEntryLink.url,
    label = _mapEntryLink.label;
  return /*#__PURE__*/jsx(Link, {
    href: url,
    children: label
  });
}
export { GlobalNavLink };
//# sourceMappingURL=GlobalNavLink.js.map
